import { PdApiActionsEnum } from "../actions/pdApiActions";

const columnDefault: State.ColumnState = {
  record: null,
  isFetching: false,
  fetchError: null,
  viewJson: null,
};

const approvalDefault: State.ApprovalState = {
  status: "none",
  comment: null,
  requestedBy: null,
  requestedAt: null,
  rejectionReason: null,
};

export const licenseUploadInitialState: State.LicenseUploadState = {
  selectedDeviceType: "",
  selectedUserGroup: "",
  tlgQa: { ...columnDefault },
  tlgProd: { ...columnDefault },
  lotaProd: { ...columnDefault },
  approval: { ...approvalDefault },
  isUploading: false,
  isPushing: false,
  uploadError: null,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function licenseUploadReducer(
  state: State.LicenseUploadState = licenseUploadInitialState,
  action: any
): State.LicenseUploadState {
  switch (action.type) {
    case PdApiActionsEnum.SET_LICENSE_DEVICE_TYPE:
      return { ...state, selectedDeviceType: action.payload };

    case PdApiActionsEnum.SET_LICENSE_USER_GROUP:
      return { ...state, selectedUserGroup: action.payload };

    // Upload to TLG QA
    case PdApiActionsEnum.UPLOAD_TLG_QA:
      return { ...state, isUploading: true, uploadError: null };

    case PdApiActionsEnum.UPLOAD_TLG_QA_SUCCESS:
      return {
        ...state,
        isUploading: false,
        uploadError: null,
        tlgQa: { ...state.tlgQa, record: action.payload, viewJson: null },
      };

    case PdApiActionsEnum.UPLOAD_TLG_QA_FAILURE:
      return { ...state, isUploading: false, uploadError: action.payload };

    // Fetch license record
    case PdApiActionsEnum.FETCH_LICENSE_RECORD: {
      const db: "qa" | "prod" | "lota" = action.payload.db;
      const columnKey = db === "qa" ? "tlgQa" : db === "prod" ? "tlgProd" : "lotaProd";
      return {
        ...state,
        [columnKey]: { ...state[columnKey], isFetching: true, fetchError: null },
      };
    }

    case PdApiActionsEnum.FETCH_LICENSE_RECORD_SUCCESS: {
      const { db, record, jsonContent } = action.payload;
      const columnKey = db === "qa" ? "tlgQa" : db === "prod" ? "tlgProd" : "lotaProd";
      return {
        ...state,
        [columnKey]: { record, isFetching: false, fetchError: null, viewJson: jsonContent },
      };
    }

    case PdApiActionsEnum.FETCH_LICENSE_RECORD_FAILURE: {
      const { db, error } = action.payload;
      const columnKey = db === "qa" ? "tlgQa" : db === "prod" ? "tlgProd" : "lotaProd";
      return {
        ...state,
        [columnKey]: { ...state[columnKey], isFetching: false, fetchError: error },
      };
    }

    // Push to Prod
    case PdApiActionsEnum.PUSH_TO_PROD:
      return { ...state, isPushing: true };

    case PdApiActionsEnum.PUSH_TO_PROD_SUCCESS:
      return {
        ...state,
        isPushing: false,
        tlgProd: { ...state.tlgProd, record: action.payload, viewJson: null },
      };

    case PdApiActionsEnum.PUSH_TO_PROD_FAILURE:
      return { ...state, isPushing: false };

    // Request LOTA
    case PdApiActionsEnum.REQUEST_LOTA:
      return { ...state, isPushing: true };

    case PdApiActionsEnum.REQUEST_LOTA_SUCCESS:
      return {
        ...state,
        isPushing: false,
        approval: {
          ...state.approval,
          status: "pending",
          requestedBy: action.payload.requestedBy,
          requestedAt: action.payload.requestedAt,
          comment: null,
          rejectionReason: null,
        },
      };

    case PdApiActionsEnum.REQUEST_LOTA_FAILURE:
      return { ...state, isPushing: false };

    // Approve LOTA
    case PdApiActionsEnum.APPROVE_LOTA:
      return { ...state, isPushing: true };

    case PdApiActionsEnum.APPROVE_LOTA_SUCCESS:
      return {
        ...state,
        isPushing: false,
        approval: { ...state.approval, status: "approved", rejectionReason: null },
        lotaProd: { ...state.lotaProd, record: action.payload, viewJson: null },
      };

    case PdApiActionsEnum.APPROVE_LOTA_FAILURE:
      return { ...state, isPushing: false };

    // Reject LOTA
    case PdApiActionsEnum.REJECT_LOTA:
      return { ...state, isPushing: true };

    case PdApiActionsEnum.REJECT_LOTA_SUCCESS:
      return {
        ...state,
        isPushing: false,
        approval: { ...state.approval, status: "rejected", rejectionReason: action.payload },
      };

    case PdApiActionsEnum.REJECT_LOTA_FAILURE:
      return { ...state, isPushing: false };

    default:
      return state;
  }
}
